import { Component, Input } from '@angular/core';
import { LoProgress } from 'lo-design-system';

@Component({
	standalone: true,
	selector: 'meta-limits-strip',
	imports: [LoProgress],
	template: `
		@if (max !== null && max > 0) {
		<lo-progress
			[label]="primary"
			[value]="percent"
			[middle]="primary"
			[end]="caption"
		></lo-progress>
		}
	`,
	styles: [
		`
			:host {
				display: block;
				min-width: 0;
				max-width: var(--lo-layout-popover-max);
			}
		`
	]
})
export class MetaLimitsStripComponent {
	@Input() primary = '';
	@Input() caption = '';
	@Input() consumed = 0;
	@Input() max: number | null = null;

	get percent(): number {
		if (!this.max) return 0;
		return Math.min(100, (this.consumed / this.max) * 100);
	}
}
